var _style, _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475.6 475.6",
    style: {
      enableBackground: "new 0 0 475.6 475.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#2B388F;}\r\n\t.st3{fill:#FFF100;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 237.8,
    cy: 237.8,
    r: 219.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 237,
    cy: 230.1,
    r: 225
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.6,71.9C270.2,3.7,140.1,22.6,71.9,114S22.5,335.4,114,403.7c91.4,68.2,221.4,49.4,289.7-42.1 C471.9,270.2,453,140.1,361.6,71.9z M353.5,318.9l-4.7,6.3c-8.5,11.4-24.6,13.7-36,5.2l-125.3-93.5c0,0,7.7,53,12.5,85.9 c2,14-7.7,27.1-21.7,29.1c-2.4,0.3-4.7,0.7-7,1c-14,2-27.1-7.7-29.1-21.7c-6.2-43-18.6-128.3-22.9-158c-1-6.7,0.7-13.6,4.8-19 l1.3-1.8c4-5.4,10.1-9,16.8-10c29.7-4.3,115-16.7,158-22.9c14-2,27.1,7.7,29.1,21.7c0.3,2.4,0.7,4.6,1,7c2,14-7.7,27.1-21.7,29.1 c-32.9,4.7-85.9,12.4-85.9,12.4L348,283.2C359.3,291.7,361.6,307.8,353.5,318.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M348,283.2l-125.3-93.5c0,0,53-7.7,85.9-12.4c14-2,23.7-15.1,21.7-29.1c-0.3-2.4-0.7-4.6-1-7 c-2-14-15.1-23.7-29.1-21.7c-43,6.2-128.3,18.6-158,22.9c-6.7,1-12.8,4.6-16.8,10l-1.3,1.8c-4.1,5.4-5.8,12.3-4.8,19 c4.3,29.7,16.7,115,22.9,158c2,14,15.1,23.7,29.1,21.7c2.3-0.3,4.6-0.7,7-1c14-2,23.7-15.1,21.7-29.1c-4.8-32.9-12.5-85.9-12.5-85.9 l125.3,93.5c11.4,8.5,27.5,6.2,36-5.2l4.7-6.3C361.6,307.8,359.3,291.7,348,283.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M380,47.2C275-31.2,125.7-9.5,47.2,95.6S-9.5,349.9,95.6,428.4s254.4,56.7,332.8-48.3S485.1,125.7,380,47.2z  M403.7,361.6c-68.3,91.5-198.3,110.3-289.7,42.1C22.5,335.4,3.7,205.4,71.9,114S270.2,3.7,361.6,71.9S471.9,270.2,403.7,361.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.71f42509690fd2728bf97c902351d797.svg";
export { ForwardRef as ReactComponent };